import db from './idb_dexie'

const custom_field = db.table('custom_fields')

async function addManyCustomFields(data) {
  // add a todo by passing in an object using Table.add.
  return await custom_field.bulkPut([...data])
}

async function getCustomFieldByName(name) {
  // console.log('vai pegar by name');
  return await custom_field.where('name').startsWithIgnoreCase(name).toArray(function (cf) {
    // alert('pegoouu by name');
    return cf
  });
}

async function getAllCustomFields() {
  // console.log('vai pegar todos');
  return await custom_field.toArray(function (cf) {
    // alert('pegoouu todos');
    return cf
  });
}

async function getOneCustomField(id){
  return await custom_field.where('id').equals(id).toArray(function (cf) {
    // alert('pegoouu one cf');
    return cf[0]
  });
}

async function getLastUpdatedCustomField(){
  return await custom_field.orderBy("updated_at").reverse().limit(1).toArray(function (cv) {
    return cv
  });
}

async function deleteAllCustomFields(){
  return await custom_field.clear()
}

async function deleteOneCustomField(id){
  return await custom_field.delete(id)
}

export default {
  addManyCustomFields,
  getCustomFieldByName,
  getOneCustomField,
  getAllCustomFields,
  deleteAllCustomFields,
  deleteOneCustomField,

  getLastUpdatedCustomField,
}